<template>
    <div id="chat-widget"></div>
</template>

<script>
const WIDGET_URL = "https://chat-bot-fba.optimexplus.com/chat-widget.js";

export default {
    name: "Chatbot",
    data: () => ({ scriptEl: null }),
    async mounted() {
        let token;
        let refreshToken = null;
        try {
            const { data } = await this.$admin.http.get("/api/chat/token");
            token = data.token;
            refreshToken = data.refresh_token;
        } catch (e) {
            this.$store.dispatch("messages/showToast", {
                color: "error",
                message: "Không thể lấy token chatbot. Vui lòng thử lại.",
            });
            return;
        }

        const script = document.createElement("script");
        script.src = WIDGET_URL;
        script.async = true;
        script.id = "chatbot-widget-script";
        script.onload = () => {
            window.ChatWidget.init({
                token,
                container: "#chat-widget",
                refresh_token: async () => {
                    const res = await this.$admin.http.post(
                        "/api/chat/token/refresh",
                        {
                            refresh_token: refreshToken,
                        }
                    );
                    refreshToken = res.data.refresh_token;
                    return res.data.token;
                },
            });
        };
        script.onerror = () => {
            this.$store.dispatch("messages/showToast", {
                color: "error",
                message: "Không thể tải chatbot widget. Vui lòng kiểm tra kết nối.",
            });
        };
        document.body.appendChild(script);
        this.scriptEl = script;
    },
    beforeDestroy() {
        if (this.scriptEl) {
            document.body.removeChild(this.scriptEl);
            this.scriptEl = null;
        }
    },
};
</script>


<style>

#chat-widget {
    width: 100%;
    height: calc(100vh - 72px);
}
</style>
